import { formatDateTimeReadable, Item, OrderDetails, RefundStatus } from '@nemuru-eng/js-api-client';

import { Text } from '../../../../../../../shared/components/Text';
import { OrderAction } from '../../../../../types/OrderAction';
import { OrderActionType } from '../../../../../types/OrderActionType';
import { OrderLineInAction } from '../../../../../types/OrderLineInAction';
import { transformItemToOrderLineInAction } from '../../transformItemToOrderLineInAction';

export const getOrderRefunds = (orderDetails: OrderDetails): OrderAction[] => {
  const refundActions: OrderAction[] = [];
  const currency = orderDetails.currency;
  const refunds = orderDetails.refunds;
  refunds
    ?.filter((refund) => refund.status === RefundStatus.APPROVED && refund.notified === true)
    .sort((a, b) => (a.createdAt < b.createdAt ? -1 : 1))
    .forEach((refund, index) => {
      refundActions.push({
        id: refund.id,
        type: OrderActionType.refund,
        status: refund.status,
        createdAt: refund.createdAt,
        updatedAt: refund.updatedAt,
        amount: { value: refund.amount, currency },
        orderLines:
          refund.itemIds.length > 0
            ? refund.itemIds.map((orderLineId) => {
                return transformItemToOrderLineInAction(
                  orderDetails.order.items.find((orderLine) => orderLine.id === orderLineId) as Item,
                  currency,
                ) as OrderLineInAction;
              })
            : [
                {
                  id: refund.id,
                  name: Text({ tId: 'REFUNDED_AMOUNT' }),
                  amount: { value: refund.amount, currency },
                  infoText: '',
                  tooltip: (
                    <>
                      <Text tId={'NO_ASSOCIATED_ITEMS'}></Text>
                      <p>{refund.description}</p>
                      {refund.notifiedAt && <>notified on {formatDateTimeReadable(refund.notifiedAt)}</>}
                    </>
                  ),
                },
              ],
        number: index + 1,
      });
    });
  return refundActions;
};
